import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Smart Card Required field definition
 * Boolean field with Yes/No dropdown for smart card requirement status filtering
 */
export const ADObjectSmartCardRequired = createBooleanSimpleFilterDefinition(
  'smartcardrequired',
  'Smart Card Required'
);
